import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setVideoSrc } from '../../../../../store/actions/index'
import { UploadOutlined } from '@ant-design/icons'
import { Input, Upload, message, Button, Form } from 'antd'
import api from '../../../../../services/api'
import { withTranslation } from 'react-i18next'
import { getAuthHeaders } from '@/utils/session'

const mapDispatchToProps = (dispatch, ownProps) => ({
  setVideo: (url?: string) => {
    dispatch(setVideoSrc(ownProps.id, url))
  },
})
interface videoProps {
  config: videoConfig
  id: string
  setVideo: (url?: string) => void
  t: (str: string) => string
}
interface videoConfig {
  videoSrc?: string
}
class videoBoxConfig extends Component<videoProps> {
  state = {
    loading: false,
    fileList: [],
  }
  onChange = info => {
    const { setVideo } = this.props
    let fileList = [...info.fileList]
    fileList = fileList.slice(-1)
    fileList = fileList.map(file => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.url
      }
      return file
    })
    this.setState({
      loading: true,
      fileList,
    })
    if (info.file.status === 'done') {
      const url = api['baleenUrl'] + '/' + info.file.response.name
      setVideo(url)
      message.success(this.props.t('uploadComplete'))
      this.setState({
        loading: true,
      })
    } else if (info.file.status === 'error') {
      message.error(this.props.t('uploadFailed'))
      this.setState({
        loading: false,
      })
    }
  }
  onRemove = () => {
    this.props.setVideo('')
  }
  render() {
    const { config } = this.props
    const { loading, fileList } = this.state
    const formItemLayout = {
      labelCol: {
        xs: {
          span: 4,
        },
        sm: {
          span: 4,
        },
      },
      wrapperCol: {
        xs: {
          span: 16,
        },
        sm: {
          span: 16,
        },
      },
    }
    const uploadProps = {
      action: api['uploadFile'],
      // withCredentials: true,
      data: {
        path: 'video/a.mp4',
      },
      headers: getAuthHeaders() as Record<string, string>,
      showUploadList: true,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      beforeUpload: (file, fileList) => {
        const isJpgOrPng =
          file.type === 'video/mp4' ||
          file.type === 'video/wmv' ||
          file.type === 'video/avi' ||
          file.type === 'video/m4v'
        if (!isJpgOrPng) {
          message.error(this.props.t('videoFormatError'))
          this.setState({
            loading: false,
          })
          return false
        }
        uploadProps.data.path = `video/${file.name}`
        return true
      },
    }
    return (
      <div className="videoConfigContent">
        <Form>
          <Form.Item {...formItemLayout} label="Video">
            <Upload
              {...uploadProps}
              onChange={this.onChange}
              onRemove={this.onRemove}
              fileList={fileList}
            >
              <Button loading={loading}>
                <UploadOutlined /> Upload
              </Button>
            </Upload>
          </Form.Item>
          <Form.Item {...formItemLayout} label="source">
            <Input value={config.videoSrc || ''} disabled></Input>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

export default connect(null, mapDispatchToProps)(withTranslation()(videoBoxConfig))
